<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Extenciones de servicio</span>
  </mat-toolbar>
  
  <div class="margin-container apearAnimation">
    <!-- <app-tableusr></app-tableusr> -->
  
    <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
      <mat-form-field appearance="outline" class="w-full md:w-auto">
        <mat-label>Nombre o Número de documento</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="searchString"
          (keyup.enter)="onEnter()"
        />
        <button
          *ngIf="searchString"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="searchString = ''"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  
    <div class="loading-indicator" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>
  
    <mat-form-field appearance="outline">
      <mat-label>Filtro</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
    </mat-form-field>
  
    <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
     
        <table mat-table [dataSource]="dataSource">
    
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">{{ element.usuario }} <br>
            <small>{{element.documento}}</small>
            </td>
          </ng-container>
    
          <ng-container matColumnDef="fechaCreacion">
            <th mat-header-cell *matHeaderCellDef>fechaCreacion</th>
            <td mat-cell *matCellDef="let element">{{ element.fechaCreacion | date: "dd-MM-yyyy hh:mm a" }}</td>
          </ng-container>
    
          <ng-container matColumnDef="fechaAnterior">
            <th mat-header-cell *matHeaderCellDef>fechaAnterior</th>
            <td mat-cell *matCellDef="let element">{{ element.fechaAnterior | date: "dd-MM-yyyy" }}</td>
          </ng-container>

          <ng-container matColumnDef="fechaNueva">
            <th mat-header-cell *matHeaderCellDef>fechaNueva</th>
            <td mat-cell *matCellDef="let element">{{ element.fechaNueva | date: "dd-MM-yyyy" }}</td>
          </ng-container>

          <ng-container matColumnDef="comentario">
            <th mat-header-cell *matHeaderCellDef>comentario</th>
            <td mat-cell *matCellDef="let element">{{ element.comentario  }}</td>
          </ng-container>

          <ng-container matColumnDef="asignador">
            <th mat-header-cell *matHeaderCellDef>asignador</th>
            <td mat-cell *matCellDef="let element">{{ element.usuarioCreador }}</td>
          </ng-container>
    
          <ng-container matColumnDef="botones">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
<!--               <button
                color="accent"
                mat-icon-button
                aria-label="Edit"
                (click)="edit(element)"
              >
                <mat-icon>edit</mat-icon>
              </button> -->
    
            </td>
          </ng-container>
    
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
  
  
      <mat-paginator
        #paginator
        [length]="length"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 100]"
        (page)="getServerData($event)"
      ></mat-paginator>
    </div>
  </div>
  